<template>
    <EmailDetailsLoadingContainer class="bg-gray-100" v-if="isLoading" />
    <div v-else class="w-full bg-gray-100">
        <div class="h-[32px] border-b-2 flex justify-between items-center border-gray-300 w-full sticky top-0 bg-gray-150 pl-6 pr-2">
            <div class="flex space-x-2 justify-between items-center text-xs w-full">
                <div class="text-sm text-gray-800 tracking-wide">{{ emailTemplateName }}</div>
                <div class="flex items-center space-x-2 pr-6">
                    <div class="pt-0.5 font-semibold text-gray-600" v-if="client">Client: {{ client }}</div>
                    <div class="pt-0.5 font-semibold text-gray-600">Created: {{ createdAt }}</div>
                    <div class="pt-0.5 font-semibold text-gray-600">Last Updated: {{ lastUpdated }}</div>
                </div>
            </div>
            <div v-if="editMode">
                <BaseButtonClose @click="closeEditForm" />
            </div>
            <div v-else>
                <BaseButton @click="openEditForm" class="text-xs">
                    Edit
                </BaseButton>
            </div>
        </div>
        <EmailTemplateForm 
            v-if="editMode" 
            class="h-[calc(100%-8rem)]" 
            :existing-email-template="emailTemplate" 
            :clientOptions="clientOptions"
            :emailFromOptions="emailFromOptions"
            :emailToOptions="emailToOptions"
            @submit-form="saveEmailTemplate"
            @close="closeEditForm"
        />
        <EmailTemplateReadOnly v-else :email-template="emailTemplate"  />
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import BaseButton from '../base-components/BaseButton.vue';
import BaseButtonClose from '../base-components/BaseButtonClose.vue';
import EmailDetailsLoadingContainer from './EmailDetailsLoadingContainer.vue';
import EmailTemplateReadOnly from './EmailTemplateReadOnly.vue';
import EmailTemplateForm from './EmailTemplateForm.vue';
import { updateEmailTemplate } from '@/services/EmailTemplates';
import { formatDate } from '@/composables/formatDate';

const store = useStore()
const $toast = useToast()

const props = defineProps(['emailTemplate', 'userPermissions', 'emailToOptions', 'emailFromOptions', 'clientOptions', 'isLoading'])

const emit = defineEmits(['close-details', 'refetch-results'])

const editMode = ref(false)

const emailTemplateName = computed(() => {
    return props.emailTemplate ? props.emailTemplate.email_template_name : '';
})

const client = computed(() => {
    return props.emailTemplate && props.emailTemplate.client ? props.emailTemplate.client.client_name : null
})

const createdAt = computed(() => {
    return props.emailTemplate ? formatDate(props.emailTemplate.created_at) : '--'
})

const lastUpdated = computed(() => {
    return props.emailTemplate ? formatDate(props.emailTemplate.updated_at) : '--'
})

watch(() => props.emailTemplate, (newTemplate, oldTemplate) => {
    if((oldTemplate && newTemplate) && (oldTemplate.id != newTemplate.id)) {
        closeEditForm()
    }
}, {deep: true})

function openEditForm() {
    editMode.value = true
}

function closeEditForm() {
    editMode.value = false
}

function refetch() {
    emit('refetch-results')
}

async function saveEmailTemplate(formData) {
    console.log('saveEmailTemplate', formData)
    const token = store.state.auth.token
    const response = await updateEmailTemplate(token, props.emailTemplate.id, formData)
    // console.log(response)
    if(response.status==204) {
        $toast.open({
            message: `Updated email template ${props.emailTemplate.email_template_name}`,
            type: 'success',
            duration: 3000
        })
        closeEditForm()
        refetch()
    } else {
        $toast.open({
            message: `Could not update email template`,
            type: 'error',
            duration: 5000
        })
    }

}
</script>